import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import '../styles/auth.css';

const Login = () => {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  // Google One Tap is disabled via useOneTap={false} prop

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      await loginWithGoogle(credentialResponse.credential);
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Google login failed');
    }
  };

  const handleGoogleError = () => {
    toast.error('Google login failed');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img src="/mmg_original.svg" alt="Company Logo" className="auth-logo" />
          <h1>TimeTrack</h1>
          <p>Attendance Management</p>
        </div>

        <div className="google-login-wrapper">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            theme="outline"
            size="large"
            width="100%"
            text="signin_with"
            useOneTap={false}
            ux_mode="popup"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
